import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  PlatformTab,
  PlatformTabChildren,
  PlatformTabSection,
} from 'src/models/platform/_types';

export interface DecoratedNavItemSection
  extends Omit<PlatformTabSection, 'children'> {
  children: DecoratedNavItem[];
}

export interface DecoratedNavItemChildren
  extends Omit<PlatformTabChildren, 'items' | 'sections'> {
  items?: DecoratedNavItem[];
  sections?: DecoratedNavItemSection[];
}

export interface DecoratedNavItem extends Omit<PlatformTab, 'children'> {
  children?: DecoratedNavItem[] | DecoratedNavItemChildren;
  icon?: IconDefinition;
}

export const isSectionedNavChildren = (
  children: DecoratedNavItem['children']
): children is DecoratedNavItemChildren => {
  return !!children && !Array.isArray(children);
};

export const getNavItemChildren = (
  item?: Pick<DecoratedNavItem, 'children'>
): DecoratedNavItem[] => {
  const children = item?.children;

  if (!children) {
    return [];
  }

  if (Array.isArray(children)) {
    return children;
  }

  return [
    ...(children.items || []),
    ...(children.sections || []).flatMap((section) => section.children),
  ];
};

export const hasNavItemChildren = (
  item?: Pick<DecoratedNavItem, 'children'>
) => getNavItemChildren(item).length > 0;
